import { render, staticRenderFns } from "./SchemaInputForm.vue?vue&type=template&id=e2edd4d6&scoped=true&"
import script from "./SchemaInputForm.vue?vue&type=script&lang=js&"
export * from "./SchemaInputForm.vue?vue&type=script&lang=js&"
import style0 from "./SchemaInputForm.vue?vue&type=style&index=0&id=e2edd4d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2edd4d6",
  null
  
)

export default component.exports